module.exports = "https://static.wmbcdn.com/uniweb/images/a2e60dc35f1689440655bd5f7e33cd3e.svg";